import React, { memo, Fragment, useMemo } from 'react';
import { GCDropdown } from '@modules/common/GCDropdown';
import { Button } from 'reactstrap';
import { TaskStatusResponse } from '@business/entities/task_status';
import { R } from '@core/utils/r';
import { Color } from '@core/utils/css';
import { openAddEditTaskStatus } from '@modules/settings/SettingsPage/Components/StatusTab/AddEditTaskStatusModal';
import { CommonService, UserService } from '@business/services';
import { Session } from '@modules/auth/session';

const styles = {
  link: {
    backgroundColor: 'rgb(255 255 255)',
    border: '1px solid #ced4da',
    borderRadius: '6px',
    color: 'gray',
    cursor: 'pointer',
  },
};

export interface TaskStatusSelectorProps {
  item?: TaskStatusResponse;
  statuses: TaskStatusResponse[];
  onSelect(status: TaskStatusResponse | undefined): void;
  left?: boolean;
}

export const TaskStatusSelector = memo((props: TaskStatusSelectorProps) => {
  const { item = null, onSelect, statuses } = props;

  const buttonStyles = useMemo(() => {
    if (!item) return {};
    return { backgroundColor: item.color, color: Color.isDark(item.color) ? 'white' : 'black', border: 0 };
  }, [item]);

  const target = useMemo(() => {
    return (
      <Button size={'sm'} outline color="dark" type="button" style={{ ...styles.link, ...buttonStyles }}>
        {item ? (
          <div>
            <span className="mr-1">{item.name}</span>
            <span
              onClick={e => {
                e.stopPropagation();
                onSelect(undefined);
              }}
              className="ml-2 fa fa-times"
            ></span>
          </div>
        ) : (
          <span>Select Status</span>
        )}
      </Button>
    );
  }, [buttonStyles, item, onSelect]);

  return (
    <GCDropdown target={target} left={props.left}>
      {setOpen => (
        <Fragment>
          {statuses.map((p, index) => (
            <a
              key={index}
              className="dropdown-item"
              onClick={() => {
                setOpen(false);
                onSelect(p);
              }}
            >
              <i className="mdi mdi-circle mr-2" style={{ color: p.color }}></i>
              <span>{p.name}</span>
            </a>
          ))}
          {UserService.isAdmin(Session.user) && (
            <Fragment>
              <div className="dropdown-divider"></div>
              <a
                className="dropdown-item"
                onClick={() => {
                  setOpen(false);
                  openAddEditTaskStatus({});
                }}
              >
                <i className="mdi mdi-plus mr-2"></i>
                <span>Add Status</span>
              </a>
            </Fragment>
          )}
        </Fragment>
      )}
    </GCDropdown>
  );
});
